import React from 'react';

export type RecentActivityProps = {
  color: string; // e.g. "bg-blue-100 text-blue-700"
  title: string;
  time: string;
  icon?: React.ReactNode;
};

const RecentActivity: React.FC<RecentActivityProps> = ({ color, title, time, icon }) => {
  return (
    <div
      className={`p-4 text-[#2B1C25] [#621C43] rounded-md flex justify-between items-center ${color}`}
    >
      {icon && <div className="mr-3">{icon}</div>}
      <div className="flex-1 flex flex-col">
        <span className="font-medium">{title}</span>
        <span className="text-xs">{time}</span>
      </div>
    </div>
  );
};

export default RecentActivity;
